/**
 * Download a file from a URL
 */
export function downloadFile(url: string, filename: string = ""): void {
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

/**
 * Extract filename from Content-Disposition header
 * Handles both quoted and unquoted filenames
 */
export function extractFilenameFromHeader(
  contentDisposition: string | null,
  defaultFilename: string = "download"
): string {
  if (!contentDisposition) return defaultFilename;

  // Try to match filename="..." or filename=...
  const filenameMatch = contentDisposition.match(/filename[^;=\n]*=["']?([^"'\n]*)["']?/);
  if (filenameMatch && filenameMatch[1]) {
    return filenameMatch[1];
  }

  return defaultFilename;
}

/**
 * Download a blob with automatic URL cleanup
 * @param blob - The blob to download
 * @param filename - The filename to save as
 */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = window.URL.createObjectURL(blob);
  try {
    downloadFile(url, filename);
  } finally {
    // Clean up the blob URL after a short delay to ensure download starts
    setTimeout(() => window.URL.revokeObjectURL(url), 100);
  }
}

/**
 * Download a blob from an axios response
 * Automatically extracts filename from Content-Disposition header
 * @param response - Axios response with blob data
 * @param defaultFilename - Fallback filename if header is not present
 * @returns The extracted filename
 */
export function downloadBlobFromResponse(
  response: { data: Blob; headers: any },
  defaultFilename: string = "download"
): string {
  const filename = extractFilenameFromHeader(
    response.headers["content-disposition"],
    defaultFilename
  );
  downloadBlob(response.data, filename);
  return filename;
}
